<template>
  <div>
    <TitlePage :title="$t('bookingsManagement')"></TitlePage>

<!--    <v-layout>-->
    <div class="pa-3">
      <v-row style="margin-top: 10px" v-if="getUser.super_admin">
        <v-col cols="12" md="12">
          <CenterSelectSearch
              v-model="filter.center_id"
              :multiple="false"
              :includeAllOption="false"
              autoStrategy="user"
              :returnObject="false"
              @message="setCenterId"
          />
        </v-col>
      </v-row>
      <v-row style="margin-top: 10px">
        <template v-if="filter.center_id">
          <v-col cols="12" md="4">
            <v-btn
                :color="(mode === 'center_daily') ? 'primary' : 'secondary'"
                @click="mode = 'center_daily'"
                class="mt-2 mb-2"
                block
            >
              VISTA GIORNALIERA
            </v-btn>
          </v-col>
          <v-col cols="12" md="4">
            <v-btn :color="(mode === 'field') ? 'primary' : 'secondary'" @click="mode='field'" class="mt-2 mb-2" block>
              VISUALIZZAZIONE PER CAMPO
            </v-btn>
          </v-col>
          <v-col cols="12" md="4">
            <v-btn :color="(mode === 'sport') ? 'primary' : 'secondary'" @click="mode='sport'" class="mt-2 mb-2" block>
              VISUALIZZAZIONE PER SPORT
            </v-btn>
          </v-col>
          <template v-if="mode === 'field'">
            <template>
              <v-col cols="12" xs="12" md="12">
                <v-select :items="field_list" label="Seleziona campo" item-text="name" item-value="_id"
                          v-model="selected_field" hide-details prepend-icon="mdi-stadium-variant" @change="showFieldCalendar()" outlined>
                </v-select>
              </v-col>
              <template v-if="calendar_to_show_by_field.length > 0">
                <template v-for="cal in this.calendar_to_show_by_field">
                  <v-col cols="12" xs="12" md="12" class="pa-0 ma-0">
                    <hr/>
                  </v-col>
                  <v-col cols="12" xs="12" md="12" class="pa-0 ma-0">
                    <LiveCalendar :selected_field="cal._id"></LiveCalendar>
                  </v-col>
                </template>
              </template>
            </template>
          </template>

          <template v-else-if="mode === 'sport'">
            <template>
              <v-col cols="12" md="12">
                <v-select :items="sport_list" label="Seleziona sport" item-text="name" item-value="_id"
                          v-model="selected_sport" hide-details prepend-icon="mdi-stadium-variant" @change="showSportCalendar()" outlined>
                </v-select>
              </v-col>
              <template v-if="calendar_to_show_by_sport.length > 0">
                <template v-for="cal in this.calendar_to_show_by_sport">
                  <v-col cols="12" md="12" class="pa-0 ma-0">
                    <LiveCalendar :selected_field="cal._id"></LiveCalendar>
                  </v-col>
                  <v-col cols="12" md="12" class="pa-0 ma-0 mt-5 pt-5">
                    <hr/>
                  </v-col>
                </template>
              </template>
            </template>
          </template>

          <template v-else-if="mode === 'center_daily'">
            <v-col cols="12" class="pa-0 ma-0">
              <CenterDailyCalendar
                  v-if="fields_complete_list.length > 0"
                  :center-id="filter.center_id"
                  :fields="fields_complete_list"
              />
            </v-col>
          </template>
        </template>
      </v-row>
    </div>

<!--    </v-layout>-->
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import LiveCalendar from "@/components/admin/LiveCalendar.vue";
import CenterAutocomplete from "@/components/admin/CenterAutocomplete.vue";
import CenterDailyCalendar from "@/components/calendar/CenterDailyCalendar.vue";
import CenterSelectSearch from "@/components/filters/CenterSelectSearch.vue";

export default {
  name: "BookingsManagement",
  components: {CenterSelectSearch, CenterDailyCalendar, CenterAutocomplete, LiveCalendar, TitlePage},
  data() {
    return {
      mode: '',
      fields_complete_list: [],
      field_list:[],
      sport_list:[],
      selected_field:null,
      selected_sport:null,
      calendar_to_show_by_field: [],
      calendar_to_show_by_sport: [],
      filter:{},
    };
  },
  computed: {
    ...mapGetters({
      'getEndpoint': 'settings/getEndpoint',
      'getUser': 'user/getUser',
      'getManagement': 'bookings/getManagement',
    }),
  },

  async created() {
    if(this.getManagement && this.getManagement.fields_complete_list.length > 0){
      await this.restoreSettings()
    }else {
      if(!this.getUser.super_admin){
        this.filter = {
          center_id: this.getUser.center_id
        }
        await this.getData()
      }
    }
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',

    }),
    ...mapActions({
      'getFields': 'fields/getCompleteList',
      'setManagement':'bookings/setManagement'
    }),

    async getData(){
      this.setLoading(true);
      let fields = await this.getFields(this.filter);
      for(let field of fields.results){
        if(field.active){
          field.sports_list = []
          for(let sport of field.sports_info){
            this.sport_list.push({name:sport.name, _id: sport.name})
            field.sports_list.push(sport.name)
          }
          let sports = field.sports_info.map(item => item['name']).join(', ');
          this.field_list.push({name:field.name+' - '+sports, _id: field._id})
          this.field_list = this.field_list.sort((a, b) => {
            if (a['name'].toLowerCase() < b['name'].toLowerCase()) {
              return -1;
            }
            if (a['name'].toLowerCase() > b['name'].toLowerCase()) {
              return 1;
            }
            return 0;
          });

          this.fields_complete_list.push(field)
        }
      }
      this.setLoading(false);
    },

    async setCenterId(id) {
      if(id){
        this.filter.center_id = id
        await this.getData()
        this.mode = 'center_daily'
        this.$forceUpdate();
      }else {
        this.mode = ''
        this.fields_complete_list = []
        this.field_list = []
        this.sport_list = []
        this.selected_field = null
        this.selected_sport = null
        this.calendar_to_show_by_field = []
        this.calendar_to_show_by_sport = []
        this.filter = {}
        this.$forceUpdate();
      }

    },

    async showFieldCalendar(){
      this.calendar_to_show_by_field = [{_id: this.selected_field}]
      await this.saveSettings()
    },

    async showSportCalendar(){
      this.calendar_to_show_by_sport = []
      for(let field of this.fields_complete_list){
        if(field.sports_list.includes(this.selected_sport)){
          this.calendar_to_show_by_sport.push({_id: field._id, name:field.name})
        }
      }
      await this.saveSettings()
    },

    async saveSettings(){
      await this.setManagement({
        mode: this.mode,
        fields_complete_list: this.fields_complete_list,
        field_list:this.field_list,
        sport_list:this.sport_list,
        selected_field:this.selected_field,
        selected_sport:this.selected_sport,
        calendar_to_show_by_field: this.calendar_to_show_by_field,
        calendar_to_show_by_sport: this.calendar_to_show_by_sport,
        filter: this.filter})
    },
    async restoreSettings(){
      this.mode = this.getManagement.mode
      this.fields_complete_list = this.getManagement.fields_complete_list
      this.field_list = this.getManagement.field_list
      this.sport_list = this.getManagement.sport_list
      this.selected_field = this.getManagement.selected_field
      this.selected_sport = this.getManagement.selected_sport
      this.calendar_to_show_by_field = this.getManagement.calendar_to_show_by_field
      this.calendar_to_show_by_sport = this.getManagement.calendar_to_show_by_sport
      this.filter = this.getManagement.filter
    }

  },
  mounted() {

  }
}
</script>

<style scoped>

</style>